<template>
  <div class="uk-margin">
    <label class="uk-form-label">
      Tags ({{ selectedIds.length }}/{{ maxTags }})
    </label>
    <div class="uk-form-controls uk-margin-small-top">
      <div v-if="selectedTags.length" class="uk-margin-small-bottom">
        <span
          v-for="tag in selectedTags"
          :key="tag.id"
          class="uk-label design-tag-selected"
        >
          {{ tag.name }}
          <button
            :aria-label="`Remove ${tag.name}`"
            class="design-tag-remove"
            type="button"
            @click="toggle(tag)"
          >
            &times;
          </button>
        </span>
      </div>

      <p v-if="!tags.length" class="uk-text-muted uk-margin-remove">
        No tags yet. Add them with Manage Tags.
      </p>
      <template v-else>
        <button
          :aria-expanded="panelOpen ? 'true' : 'false'"
          class="uk-button uk-button-default uk-button-small"
          type="button"
          @click="panelOpen = !panelOpen"
        >
          {{ panelOpen ? "Done" : "+ Add tags" }}
        </button>

        <div v-if="panelOpen" class="design-tag-panel uk-margin-small-top">
          <input
            v-model="filter"
            class="uk-input uk-form-small"
            type="search"
            placeholder="Filter tags"
            aria-label="Filter tags"
          />
          <ul class="uk-margin-small-top design-tag-list">
            <li v-for="tag in filteredTags" :key="tag.id">
              <label>
                <input
                  :checked="isSelected(tag)"
                  :disabled="!isSelected(tag) && atLimit"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="toggle(tag)"
                />
                {{ tag.name }}
              </label>
            </li>
            <li
              v-if="!filteredTags.length"
              class="uk-text-muted design-tag-list-empty"
            >
              No tags match "{{ filter }}".
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  MAX_TAGS_PER_DESIGN,
  existingTagIds,
  resolveTags
} from "@/utils/designTags";

export default {
  name: "DesignTagPicker",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      maxTags: MAX_TAGS_PER_DESIGN,
      panelOpen: false,
      filter: ""
    };
  },
  computed: {
    selectedIds() {
      return existingTagIds(this.value, this.tags);
    },
    selectedTags() {
      return resolveTags(this.value, this.tags);
    },
    filteredTags() {
      const query = this.filter.trim().toLowerCase();
      return this.tags.filter(tag => tag.name.toLowerCase().includes(query));
    },
    atLimit() {
      return this.selectedIds.length >= this.maxTags;
    }
  },
  methods: {
    isSelected(tag) {
      return this.selectedIds.includes(tag.id);
    },
    toggle(tag) {
      if (this.isSelected(tag)) {
        this.$emit(
          "input",
          this.selectedIds.filter(id => id !== tag.id)
        );
      } else if (!this.atLimit) {
        this.$emit("input", [...this.selectedIds, tag.id]);
      }
    }
  }
};
</script>

<style type="text/css">
.design-tag-selected {
  margin: 0 5px 5px 0;
  text-transform: none;
}
.design-tag-remove {
  margin-left: 4px;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}
.design-tag-panel {
  padding: 10px;
  border: 1px solid #e5e5e5;
}
.design-tag-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 20px;
  max-height: 200px;
  margin-bottom: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
}
.design-tag-list-empty {
  grid-column: 1 / -1;
}
@media (max-width: 640px) {
  .design-tag-list {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/DesignTagPicker.vue